(function () {
  'use strict';
 
  function initMarquee(root) {
    var track = root.querySelector('[data-kyst-marquee-track]');
    var firstGroup = root.querySelector('[data-kyst-marquee-group]');
    if (!track || !firstGroup) return;
 
    var prefersReducedMotion =
      window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (prefersReducedMotion) return; // Leave the bar static.
 
    var baseSpeed = parseFloat(root.getAttribute('data-speed')) || 40; // px/s at rest
    var groupWidth = 0;
    var position = 0;
    var direction = -1; // -1 = moving left (default idle direction), 1 = moving right
    var lastScrollY = window.scrollY || window.pageYOffset || 0;
    var lastFrameTime = null;
    var scrollBoost = 0; // extra speed added while/just after scrolling, eases back to 0
 
    function fillTrack() {
      groupWidth = firstGroup.getBoundingClientRect().width;
      if (groupWidth === 0) return;
 
      var viewportWidth = root.getBoundingClientRect().width || window.innerWidth;
      var minWidth = viewportWidth * 2 + groupWidth;
 
      // Duplicate the message group until there is always enough content
      // on screen in both directions, whatever the merchant put in it.
      var guard = 0; // safety net against an infinite loop
      while (track.getBoundingClientRect().width < minWidth && guard < 20) {
        var clone = firstGroup.cloneNode(true);
        clone.setAttribute('aria-hidden', 'true');
        track.appendChild(clone);
        guard += 1;
      }
    }
 
    fillTrack();
 
    var resizeTimer = null;
    window.addEventListener('resize', function () {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(function () {
        groupWidth = firstGroup.getBoundingClientRect().width;
        fillTrack();
      }, 200);
    });
 
    window.addEventListener(
      'scroll',
      function () {
        var currentY = window.scrollY || window.pageYOffset || 0;
        var delta = currentY - lastScrollY;
        lastScrollY = currentY;
 
        // Scrolling down moves the bar left, scrolling up moves it right.
        if (delta > 0.5) {
          direction = -1;
        } else if (delta < -0.5) {
          direction = 1;
        }
 
        scrollBoost = Math.min(Math.abs(delta) * 6, 260);
      },
      { passive: true }
    );
 
    function frame(time) {
      if (lastFrameTime === null) lastFrameTime = time;
      var dt = Math.min((time - lastFrameTime) / 1000, 0.05);
      lastFrameTime = time;
 
      // Ease the scroll boost back down so the bar settles to its base speed
      // once you stop scrolling, instead of stopping abruptly.
      scrollBoost += (0 - scrollBoost) * Math.min(dt * 4, 1);
 
      var speed = baseSpeed + scrollBoost;
      position += direction * speed * dt;
 
      if (groupWidth > 0) {
        if (position <= -groupWidth) position += groupWidth;
        if (position > 0) position -= groupWidth;
      }
 
      track.style.transform = 'translateX(' + position + 'px)';
      requestAnimationFrame(frame);
    }
 
    requestAnimationFrame(frame);
  }
 
  function initAll() {
    var marquees = document.querySelectorAll('[data-kyst-marquee]');
    marquees.forEach(initMarquee);
  }
 
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }
 
  document.addEventListener('shopify:section:load', function (event) {
    var marquee = event.target.querySelector('[data-kyst-marquee]');
    if (marquee) initMarquee(marquee);
  });
})();
 

